/* Shared helpers: money format, bag count, toast, mobile menu, FAQ fallback. */
(function () {
  'use strict';
  var T = window.theme = window.theme || {};

  /* Shopify money format → string. Whole amounts drop ".00" ($59, $49.50). */
  T.formatMoney = function (cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    function num(n, dec, th, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      var s = p.join(ds);
      return s.replace(new RegExp('\\' + ds + '00$'), '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      return num(cents, 2, ',', '.');
    });
  };

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  T.refreshCart = function () {
    return fetch((T.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  };

  var toastTimer;
  T.toast = function (msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = true; void el.offsetWidth; el.hidden = false; // restart the pop animation
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  };

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('mobile-nav');
    if (btn && nav) {
      btn.addEventListener('click', function () {
        nav.hidden = !nav.hidden;
        btn.setAttribute('aria-expanded', String(!nav.hidden));
      });
    }

    /* One FAQ open at a time, for browsers without <details name>. */
    if (!('name' in HTMLDetailsElement.prototype)) {
      document.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.open || !d.getAttribute('name')) return;
        document.querySelectorAll('details[name="' + d.getAttribute('name') + '"][open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    }
  });

  /* Pages restored from the back/forward cache keep a stale bag count. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) T.refreshCart().catch(function () {}); });
})();
